import React, { useState, useContext, useCallback } from 'react';
import { TextButton, Typography, visuallyHidden } from 'bonfire-kindling';
import { LocationPicker } from 'components';
import { useTranslation } from 'react-i18next';
import axios from 'helpers/axios';
import WelcomeFooter from '../WelcomeFooter';
import { ToastContext } from 'contexts';
import { VENDORS_ME } from 'constants/apis';
import { locationsToRegionData } from 'helpers/locations';

const PAPER_MAX_WIDTH = '1000px';

const Welcome4 = ({ values, decrementIndex, onSubmit, onChange }) => {
  const toastContext = useContext(ToastContext);
  const { t } = useTranslation();
  const [isSaving, setIsSaving] = useState(false);

  const handleSubmit = useCallback(
    async selectedLocations => {
      const payload = {
        regionData: locationsToRegionData(selectedLocations),
      };
      setIsSaving(true);
      try {
        await axios.patch(VENDORS_ME, payload);
        onSubmit({ selectedLocations });
        toastContext.triggerToast({ variant: 'success' });
      } catch (err) {
        toastContext.triggerToast({});
        setIsSaving(false);
      }
    },
    [onSubmit, toastContext]
  );
  const handleChange = useCallback(
    selectedLocations => {
      onChange({ selectedLocations });
    },
    [onChange]
  );

  const footer = (
    <WelcomeFooter isStickyBar stickyWidth={PAPER_MAX_WIDTH}>
      <TextButton
        variant="text"
        onClick={decrementIndex}
        label={`< ${t('components.back')}`}
        sx={{ fontWeight: '600' }}
      />
      <TextButton
        type="submit"
        variant="contained"
        color="primary"
        isBusy={isSaving}
        disabled={values.selectedLocations.length === 0}
        label={t('welcome.save_next')}
      />
    </WelcomeFooter>
  );

  return (
    <>
      <Typography component="h1" sx={visuallyHidden}>
        {t('welcome.location.title')}
      </Typography>
      <Typography
        variant="h4"
        component="h2"
        sx={{
          marginBottom: theme => theme.spacing(3),
        }}
      >
        {t('welcome.location.intro')}
      </Typography>
      <Typography variant="body2">{t('welcome.location.reason')}</Typography>
      <LocationPicker
        formFooter={footer}
        initialValues={values.selectedLocations}
        onChange={handleChange}
        onSubmit={handleSubmit}
        isOnboarding
      />
    </>
  );
};

export default Welcome4;
